import React from 'react';
import FileNotFound from '../FileNotFound';

const FeatureDisabled = () => {
  return (
    <FileNotFound>Equipment sales is disabled. Check with administrator on how to turn this feature on.</FileNotFound>
  );
};

export default FeatureDisabled;
